import { TextInput } from '@mantine/core';
import { CreateFullPageStep } from '@carbon/ibm-products';
import { MessageDescriptor, useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';

import styles from '../../InitialSetupModal.module.scss';
import ParishInfoCard from 'Components/Common/ParishInfoCard/ParishInfoCard';

type Props = {
    title: MessageDescriptor;
    groupNameLabel: MessageDescriptor;
    websiteLabel: MessageDescriptor;
    entityName: string;
    entityEmail: string;
    entityPhoneNumber: string;
    entityWebsite: string;
    isEntityEmailValid: boolean;
    isEntityPhoneNumberValid: boolean;
    isDisabled: boolean;
    onMount?: () => void;
    onEntityNameChange: (value: string) => void;
    onEntityEmailChange: (value: string) => void;
    onEntityPhoneNumberChange: (value: string) => void;
    onEntityWebsiteChange: (value: string) => void;
};

const GroupStep = ({
    title,
    groupNameLabel,
    websiteLabel,
    entityName,
    entityEmail,
    entityPhoneNumber,
    entityWebsite,
    isEntityEmailValid,
    isEntityPhoneNumberValid,
    isDisabled,
    onMount,
    onEntityNameChange,
    onEntityEmailChange,
    onEntityPhoneNumberChange,
    onEntityWebsiteChange,
}: Props) => {
    const intl = useIntl();

    return (
        <CreateFullPageStep
            title={intl.formatMessage(title)}
            fieldsetLegendText=""
            disableSubmit={isDisabled}
            onMount={onMount}
        >
            <div className={styles.groupsContainer}>
                <div className={styles.stepContainer}>
                    <TextInput
                        id="initial-setup-group-name"
                        classNames={{
                            root: styles.setupFieldRoot,
                            label: styles.setupFieldLabel,
                            input: styles.setupFieldInput,
                        }}
                        label={intl.formatMessage(groupNameLabel)}
                        value={entityName}
                        onChange={(event) => { onEntityNameChange(event.target.value); }}
                        size="md"
                        required
                    />
                    <TextInput
                        id="initial-setup-group-email"
                        classNames={{
                            root: styles.setupFieldRoot,
                            label: styles.setupFieldLabel,
                            input: styles.setupFieldInput,
                        }}
                        label={intl.formatMessage(sharedMessages.parishEmail)}
                        value={entityEmail}
                        error={!isEntityEmailValid ? intl.formatMessage(sharedMessages.incorrectEmail) : undefined}
                        onChange={(event) => { onEntityEmailChange(event.target.value); }}
                        size="md"
                    />
                    <TextInput
                        id="initial-setup-group-phone"
                        classNames={{
                            root: styles.setupFieldRoot,
                            label: styles.setupFieldLabel,
                            input: styles.setupFieldInput,
                        }}
                        label={intl.formatMessage(sharedMessages.parishPhoneNumber)}
                        value={entityPhoneNumber}
                        error={!isEntityPhoneNumberValid ? intl.formatMessage(messages.invalidPhoneNumber) : undefined}
                        onChange={(event) => { onEntityPhoneNumberChange(event.target.value); }}
                        size="md"
                    />
                    <TextInput
                        id="initial-setup-group-website"
                        classNames={{
                            root: styles.setupFieldRoot,
                            label: styles.setupFieldLabel,
                            input: styles.setupFieldInput,
                        }}
                        label={intl.formatMessage(websiteLabel)}
                        value={entityWebsite}
                        onChange={(event) => { onEntityWebsiteChange(event.target.value); }}
                        size="md"
                    />
                </div>
                <ParishInfoCard className={styles.infoCard} />
            </div>

        </CreateFullPageStep>
    );
};

export default GroupStep;

const messages = {
    invalidPhoneNumber: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.GroupStep.invalidPhoneNumber',
        defaultMessage: 'Podaj numer telefonu w formacie międzynarodowym, np. +48123456789.',
    },
};
